<template>
  <div v-click-outside="onClickOutside">
    <div :class="linkClass">
      <div
        class="tw-relative tw-select-none"
        :class="`${isSidebar ? 'tw-mb-0' : 'tw-mx-2'}`"
      >
        <div
          class="tw-cursor-pointer tw-relative tw-flex tw-leading-normal tw-font-normal"
          @click="isOpen = !isOpen"
        >
          <span>{{ menuItem.name }}</span> <span><i class="tw-ml-2 fas fa-caret-down" /></span>
        </div>
        <div
          v-if="isOpen"
          class="nav-top-triangle tw-absolute tw-z-50 tw-top-0 tw-left-0 tw-right-0 tw-mx-auto tw-mt-9"
          :class="`${isSidebar ? 'tw-hidden' : 'tw-block'}`"
        />
        <ul
          :class="[
            isOpen ? 'tw-flex' : 'tw-hidden',
            isSidebar ? 'nav-dropdown-menu-sidebar' : 'nav-dropdown-menu'
          ]"
        >
          <slot />
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuItem: {
      type: Object,
      default: () => ({}),
    },
    isSidebar: {
      type: Boolean,
      default: () => false,
    },
    linkClass: {
      type: String,
      default: () => '',
    },
  },

  data() {
    return {
      isOpen: false,
    };
  },

  watch: {
    $route() {
      this.isOpen = false;
    },
  },

  methods: {
    onClickOutside() {
      this.isOpen = false;
    },
  },
};
</script>

<style>
.nav-dropdown-menu {
  left: 50% !important;
  right: auto !important;
  text-align: left !important;
  transform: translate(-50%, 0) !important;
  @apply tw-pb-2 tw-px-3 tw-mt-5 tw-pt-2 tw-flex-col tw-absolute tw-bg-white tw-z-40 tw-shadow-xl tw-border-t-4 tw-border-r tw-border-l tw-border-custom-teal tw-rounded-lg tw-max-h-60vh tw-overflow-y-auto;
}

.nav-dropdown-menu-sidebar {
  @apply tw-flex-col tw-pt-2 tw-mt-2 tw-pl-5 tw-border-l-8 tw-border-custom-teal;
}

.nav-top-triangle {
  width: 0;
  height: 0;
  background: none !important;
  background-color: none !important;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 9px solid #04b9b2;
}
</style>
